import { get, patch } from "./AXIOS"

import { GET_NOTIFICATIONS, UPDATE_NOTIFICATION } from "./CONSTANTS"

export const getNotifications = () => get(`${GET_NOTIFICATIONS}`)

export const updateNotification = (notification_id, body) => patch(UPDATE_NOTIFICATION(notification_id), body, { "headers": { "Content-Type": "application/json" } })
